import { useEffect, useRef, useState } from "react"
import { useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import moment from "moment"
import * as customerApis from "../../utilities/apis/customer"
import * as orderApis from "../../utilities/apis/order"
import * as dispatcherServices from "../../utilities/services/dispatcher"
import { isDeal } from "../../utilities/enumerations/constants"
import Layout from "../../components/Layout"
import NewMessageModal from "../../components/NewMessageModal"

import { collection, query, orderBy, onSnapshot, addDoc, serverTimestamp, doc, updateDoc, setDoc, getDoc } from "firebase/firestore";
import { db } from "../../utilities/firebase/firestore"

const Chats = () => {
  const navigate = useNavigate()
  const containerRef = useRef(null)
  const { token, user } = useSelector(state => state.user)
  const [customers, setCustomers] = useState([])
  const [selectedCustomer, setSelectedCustomer] = useState(null)
  const [messages, setMessages] = useState([])
  const [text, setText] = useState("")

  const sendMessage = async (payload) => {
    try {
      console.log(token)
      await customerApis.sendMessage(token, payload)
    } catch (error) {

    }
  }

  const handleSend = async () => {
    if (!text.trim()) return

    const messageRef = collection(db, "customers", selectedCustomer, "messages")
    await addDoc(messageRef, {
      text,
      sender: "support",
      createdAt: serverTimestamp(),
    })

    const customerRef = doc(db, "customers", selectedCustomer)
    await updateDoc(customerRef, {
      lastMessage: text,
      lastUpdated: serverTimestamp(),
    })

    await sendMessage({
      mobile: selectedCustomer,
      message: text
    })

    setText("")
  }

  const handleEnterSend = async (e) => {
    if (e.key === "Enter" && e.ctrlKey) {
      if (!e.target.value.trim()) return

      const message = e.target.value

      setText("")

      const messageRef = collection(db, "customers", selectedCustomer, "messages")
      await addDoc(messageRef, {
        text: message,
        sender: "support",
        createdAt: serverTimestamp(),
      })

      const customerRef = doc(db, "customers", selectedCustomer)
      await updateDoc(customerRef, {
        lastMessage: message,
        lastUpdated: serverTimestamp(),
      })

      await sendMessage({
        mobile: selectedCustomer,
        message: message
      })
    }
  }

  const handleSelect = async (customer) => {
    const customerRef = doc(db, "customers", customer.mobile)
    const customerSnap = await getDoc(customerRef)

    if (!customerSnap.exists()) {
      await setDoc(customerRef, {
        name: customer.name,
        lastMessage: "",
        lastUpdated: null,
      })
    }
    setSelectedCustomer(customer.mobile)
  }

  useEffect(() => {
    if (!user) navigate("/")

    const q = query(collection(db, "customers"), orderBy("lastUpdated", "desc"))

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const data = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }))
      setCustomers(data)
    })

    return () => unsubscribe()
  }, [])

  useEffect(() => {
    if (!selectedCustomer) return

    const q = query(collection(db, "customers", selectedCustomer, "messages"), orderBy("createdAt", "asc"))

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const data = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }))
      setMessages(data)
    })

    return () => unsubscribe()
  }, [selectedCustomer])

  useEffect(() => {
    const container = containerRef.current
    container.scrollTop = container.scrollHeight
  }, [messages])

  return (
    <Layout
      header={true}
      footer={true}
    >
      <NewMessageModal handleSelect={handleSelect} />

      <main id="order" className="flex-column">
        <div className="d-flex gap-2 align-items-center p-2">
          <h3 className="fw-bold m-0">Chats</h3>
          <button type="button" className="btn btn-sm btn-primary" data-bs-toggle="modal" data-bs-target="#newMessageModal"><i className="fas fa-edit"></i></button>
        </div>

        <div className="flex-grow-1 d-flex overflow-y-auto border-top">
          <aside className="w-25 border-end">
            <div className="list-group shadow-none">
              {customers.map((customer) => {
                return (
                  <a onClick={() => setSelectedCustomer(customer.id)} key={customer.id} className={`list-group-item list-group-item-action border-0 border-bottom rounded-0 ${customer.id === selectedCustomer ? "active" : ""}`}>{customer.name}<br /><span className="small">{customer.id}</span></a>
                )
              })}
            </div>
          </aside>
          <section className="w-75 border-start d-flex flex-column">
            <div ref={containerRef} id="messages" className="flex-grow-1 overflow-y-auto px-2">
              {messages.map((message) => {
                return (
                  <div key={message.id} className={`${message.sender} ${message.sender === "customer" ? "bg-dark" : "bg-primary"} text-left text-white p-2 rounded my-2`}>
                    <p>{message.text}</p>
                    {message.createdAt && <p className="m-0 small text-end">{moment(message.createdAt.seconds * 1000).format("HH:mm")}</p>}
                  </div>
                )
              })}
            </div>
            <div className="d-flex gap-2 align-items-end border-top p-2">
              <textarea className="form-control form-control-lg" placeholder="Type Message" rows={2} value={text} onChange={(e) => setText(e.target.value)} onKeyUp={handleEnterSend}></textarea>
              <button type="button" className="btn btn-lg btn-primary" onClick={handleSend}>Send</button>
            </div>
          </section>
        </div>
      </main>
    </Layout>
  )
}

export default Chats
